/**
 * @author       Pavlo Androshchuk
 * @copyright    Copyright (c) 2022, Zumper
 */

import { selectGlobalNavRFRLinks } from '@zcode-ui/web-zumper-global-state'
import React, { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { TRACK_USER_MENU_ACTION } from '../../../../constants'
import { usePathname } from '../../../../hooks/usePathname'
import {
  type ExtraNavLink,
  getMenuNavLinks,
  getRFRMenuNavDefaulLinks,
} from '../../../../utils/getMenuNavLinks'
import { UserLinksSubmenu } from '../UserLinksSubmenu'

interface HFRUserSubmenuProps {
  onLinkClick: (name: string, href: string) => void
}

const EXTRA_LINKS = [
  {
    name: 'Near Me',
    href: '/near-me/rooms',
    title: 'Rooms for rent near me',
    is_indexed: true,
    trackingName: TRACK_USER_MENU_ACTION.ROOMS_FOR_RENT_NEAR_ME,
  },
] as const satisfies ReadonlyArray<ExtraNavLink>

export const RFRUserSubmenu = ({ onLinkClick }: HFRUserSubmenuProps) => {
  const pathName = usePathname()
  const getLocaleLinkTitle = useCallback((name: string) => `Rooms for rent ${name}`, [])
  const rfrLinks = useSelector(selectGlobalNavRFRLinks)
  const links = useMemo(
    () =>
      rfrLinks?.length > 0
        ? getMenuNavLinks('/rooms-for-rent/', rfrLinks, 11, pathName)
        : getRFRMenuNavDefaulLinks(pathName),
    [pathName, rfrLinks]
  )
  return (
    <UserLinksSubmenu
      extraLinks={EXTRA_LINKS}
      getLocaleLinkTitle={getLocaleLinkTitle}
      links={links}
      onLinkClick={onLinkClick}
    />
  )
}
